
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("合成分类列表", ["合成分类;compound_categories"]);
    });

    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const tableData = ref([]);
    const activeTab = ref((route.query.compound_type as string) || "");

    const formData = ref({
      name: "",
      enabled: "",
    });

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    });

    const query = () => {
      const params: Record<string, unknown> = {
        ...formData.value,
        ...page.value,
      };
      if (activeTab.value) {
        params.compound_type = activeTab.value;
      }
      store
        .dispatch(Actions.GET_COMPOUND_CATEGORIES, params)
        .then(() => {
          tableData.value = store.getters.currentCompoundCategories;
          page.value.totalResult = store.getters.currentCompoundCategoryCount;
        })
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        .catch(() => {});
    };

    query();

    const newCompoundCategory = () => {
      router.push({ name: "compound_category_new" });
    };

    const onPageChange = (e) => {
      page.value.currentPage = e.currentPage;
      query();
    };

    const onTabChange = () => {
      page.value.currentPage = 1;
      const q = { ...route.query };
      if (activeTab.value) {
        q.compound_type = activeTab.value;
      } else {
        delete q.compound_type;
      }
      router.replace({ query: q });
      query();
    };

    const onSearch = () => {
      page.value.currentPage = 1;
      query();
    };

    const onReset = () => {
      formData.value.name = "";
      formData.value.enabled = "";
      page.value.currentPage = 1;
      query();
    };

    const onSortingChange = (row) => {
      store
        .dispatch(Actions.UPDATE_COMPOUND_CATEGORY, {
          id: row.id,
          values: { sorting: row.sorting },
        })
        .then(() => {
          query();
        });
    };

    const onDelete = (id) => {
      Swal.fire({
        title: "确认删除？",
        text: "有关联合成商品的分类无法删除",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.isConfirmed) {
          store
            .dispatch(Actions.DELETE_COMPOUND_CATEGORY, id)
            .then(() => {
              query();
            })
            .catch((errorMsg) => {
              Swal.fire({
                text: errorMsg || "删除失败",
                icon: "error",
                confirmButtonText: "确认",
              });
            });
        }
      });
    };

    return {
      tableData,
      formData,
      activeTab,
      newCompoundCategory,
      page,
      onPageChange,
      onTabChange,
      onSearch,
      onReset,
      onSortingChange,
      onDelete,
    };
  },
});
